import { Row,Col } from "react-bootstrap"

export default function Heder(){
    return(
        <Row>
            <Col sm="12" className="justify-content-center text-center" >
            <div className="title">
                <h2 className="section-title">  قائمه الطعام </h2> 
            </div>
            </Col>
        </Row>
    )
}